const CHECKOUT_FOOTER_HEIGHT = 70
const FAB_GAP_ABOVE_FOOTER = 20
const DEFAULT_BOTTOM_OFFSET = 24
const FAB_RIGHT_OFFSET = 24
const FAB_SIZE = 56
const FAB_CONTENT_GAP = 16

/** Space under a page so the last row sits above the closed assistant button. */
const OLLIE_FAB_CONTENT_CLEARANCE =
  DEFAULT_BOTTOM_OFFSET + FAB_SIZE + FAB_CONTENT_GAP

/** Space to the left of the closed assistant button so list money is not covered. */
const OLLIE_FAB_INLINE_CLEARANCE = FAB_RIGHT_OFFSET + FAB_SIZE + FAB_CONTENT_GAP

/** Drop into page / tab wrappers (FS log, Purchasing dates, Groups list). */
const ollieFabPageClearanceCss = `
  padding-bottom: ${OLLIE_FAB_CONTENT_CLEARANCE}px;
  padding-right: ${OLLIE_FAB_INLINE_CLEARANCE}px;
  box-sizing: border-box;
`

const RAISED_BOTTOM_OFFSET = CHECKOUT_FOOTER_HEIGHT + FAB_GAP_ABOVE_FOOTER

function isBasketRoute(pathname = '') {
  return pathname.includes('/purchasing/basket')
}

function isCheckoutRoute(pathname = '') {
  if (pathname.includes('/checkout/success')) {
    return false
  }

  return (
    pathname.includes('/checkout') ||
    pathname.includes('/subscriptions/checkout')
  )
}

function getOllieFabBottomOffset(pathname = '') {
  if (isBasketRoute(pathname) || isCheckoutRoute(pathname)) {
    return RAISED_BOTTOM_OFFSET
  }

  return DEFAULT_BOTTOM_OFFSET
}

/** Groups / OTP overlays sit under the FAB; hide it while they are open. */
function shouldHideOllieFab({
  groupsOpen = false,
  orderToParOpen = false,
} = {}) {
  return Boolean(groupsOpen || orderToParOpen)
}

export {
  CHECKOUT_FOOTER_HEIGHT,
  DEFAULT_BOTTOM_OFFSET,
  FAB_RIGHT_OFFSET,
  FAB_SIZE,
  OLLIE_FAB_CONTENT_CLEARANCE,
  OLLIE_FAB_INLINE_CLEARANCE,
  ollieFabPageClearanceCss,
  RAISED_BOTTOM_OFFSET,
  getOllieFabBottomOffset,
  isBasketRoute,
  isCheckoutRoute,
  shouldHideOllieFab,
}
